import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmationDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: 'primary' | 'accent' | 'warn';
  /** When set, shows a Save action that closes with `'save'`. */
  saveText?: string;
}

@Component({
  selector: 'marina-confirmation-dialog',
  standalone: false,
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {
    this.data.confirmText = this.data.confirmText || 'Confirm';
    this.data.cancelText = this.data.cancelText || 'Cancel';
    this.data.confirmColor = this.data.confirmColor || 'primary';
  }

  get showSave(): boolean {
    return !!this.data.saveText;
  }

  onConfirm(): void {
    // Discard / primary confirm — keep boolean true for older callers
    this.dialogRef.close(this.showSave ? 'discard' : true);
  }

  onCancel(): void {
    this.dialogRef.close(this.showSave ? 'cancel' : false);
  }

  onSave(): void {
    this.dialogRef.close('save');
  }
}
